import { AxiosError } from "axios";
import { TransactionMessage, ValidationErrorResponse } from "./types";
import { capitalize } from "utils";

export const initialEditorValue = {};

export const conflictMessage = (resourceType: string): TransactionMessage => {
  return {
    code: "conflict",
    isError: true,
    messages: [`A ${capitalize(resourceType)} with this id already exists.`],
  };
};

export const unknownMessage = (resourceType: string): TransactionMessage => {
  return {
    code: "unknown",
    isError: true,
    messages: [`An error occurred while creating the ${capitalize(resourceType)}.`],
  };
};

export const invalidJsonMessage: TransactionMessage = {
  code: "invalid-json",
  isError: true,
  messages: ["The JSON provided is invalid."],
};

export const invalidMessage: TransactionMessage = {
  code: "invalid",
  isError: true,
  messages: [],
};

export const notAllowedMessage: TransactionMessage = {
  code: "editing collection id is not allowed",
  isError: true,
  messages: [
    "cannot update collection id, please keep collection.id same in the editor",
  ],
};

export const creatingItemMessage: TransactionMessage = {
  code: "Creating Item...",
  isError: false,
  messages: ["Creating Item... "],
};

export const failedItemCreationMessage: TransactionMessage = {
  code: "Item creation failed.",
  isError: true,
  messages: ["Item creation failed. Please check your input and try again."],
};

export const requestErrorToMessage = (
  error: AxiosError,
  resourceType: string
): TransactionMessage => {
  if (error.response?.status === 409) {
    return conflictMessage(resourceType);
  } else if (error.response?.status === 400) {
    const err = error as AxiosError<ValidationErrorResponse>;
    if (err.response?.data?.error === "ValidationError") {
      return {
        ...invalidMessage,
        messages: err.response?.data?.messages || ["The JSON provided is invalid."],
      };
    }
    return {
      ...invalidMessage,
      messages: [JSON.stringify(err.response?.data, null, 2)],
    };
  } else if (error.response?.status === 401 || error.response?.status === 403) {
    return {
      code: "unauthorized",
      isError: true,
      messages: ["You are not authorized to perform this action."],
    };
  }

  return unknownMessage(resourceType);
};

export const formatStacBody = (body: object): string => {
  return JSON.stringify(body, null, 2);
};

export const collectionTemplate = {
  id: "example-collection",
  type: "Collection",
  title: "Example Collection",
  description: "An example collection",
  license: "CC-BY-4.0",
  extent: {
    spatial: {
      bbox: [[-180, -90, 180, 90]],
    },
    temporal: {
      interval: [["2018-01-01T00:00:00Z", "2018-12-31T23:59:59Z"]],
    },
  },
  links: [],
  stac_version: "1.0.0",
  "msft:short_description": "An example collection",
};

export const configTemplate = {
  collection_settings: {
    minzoom: 12,
    max_items_per_tile: 35,
  },
  mosaic_info: {
    mosaics: [
      {
        id: "example",
        name: "Example Mosaic",
        description: "",
        cql: [],
      },
    ],
    renderOptions: [],
  },
};

export const collectionConfigUpdateTemplate = {
  collectionId: "example-collection",
  mosaics: [
    {
      id: "example",
      name: "Example Mosaic",
      description: "",
      cql: [],
    },
  ],
  renderOptions: [
    {
      id: "render-config-1",
      name: "Sample render config",
      description: "A sample render configuration. Update `options` below.",
      type: "raster-tile",
      options: "assets=<<your-asset-key>>",
      minZoom: 12,
    },
  ],
  tileSettings: {
    minZoom: 12,
    maxItemsPerTile: 35,
  },
  queryables: [
    {
      name: "queryable_name",
      definition: {},
    },
  ],
};
